import { render, staticRenderFns } from "./PublicSector.vue?vue&type=template&id=6ddc9cee&scoped=true&"
import script from "./PublicSector.vue?vue&type=script&lang=js&"
export * from "./PublicSector.vue?vue&type=script&lang=js&"
import style0 from "./PublicSector.vue?vue&type=style&index=0&id=6ddc9cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc9cee",
  null
  
)

export default component.exports